import React from 'react';
import { AnalyticsContextProvider } from '@llt-frontend/react-analytics-context';
import { BrowserRouter } from 'react-router-dom';
import { ActionTracker } from '@varsitytutors/event-tracker';
import { FetchContextProvider } from '@llt-frontend/react-fetch';
import PropTypes from 'prop-types';
import { JsonApiProvider } from './jsonapi-context';

const AT = new ActionTracker({
  applicationId: 'vt-self-service-ui',
  endpoint: `https://events.${process.env.REACT_APP_DOMAIN_NAME}/v2/pages/interaction`,
});

function AppContext({ children }) {
  return (
    <BrowserRouter basename="/">
      <FetchContextProvider>
        <JsonApiProvider>
          <AnalyticsContextProvider actionTracker={AT}>{children}</AnalyticsContextProvider>
        </JsonApiProvider>
      </FetchContextProvider>
    </BrowserRouter>
  );
}

AppContext.propTypes = {
  children: PropTypes.node.isRequired,
};

// Exports
// -------

export default AppContext;
